export const SET_NOTE_LIST = "SET_NOTE_LIST";
